<script setup lang='ts'>
import { checkEmail, checkPhone, isString } from '@qctsw/utils'
import type { FormInst, FormItemRule, FormRules } from 'naive-ui'
import { SEX } from '~/shared/constants'
import { validateHandle } from '~/shared/function'

const emits = defineEmits({
  changeCurrentStep: (_step: number) => true,
})

const { formData } = storeToRefs(usePublishStore())
const formRef = ref<FormInst | null>(null)
const rules: FormRules = {
  userName: [
    {
      required: true,
      message: '请输入车主姓名',
      trigger: 'blur',
    },
    {
      validator: (_rule: FormItemRule, value) => {
        if (!value.match((/[^\u4E00-\u9FA5]/g)))
          return true
        else
          return new Error('请输入中文姓名')
      },
      trigger: 'blur',
    },
  ],
  sex: [
    {
      required: true,
      validator: (_rule: FormItemRule, value) => {
        if (SEX.map(v => v.value).includes(value))
          return true
        else
          return new Error('请选择性别')
      },
      trigger: 'blur',
    },
  ],
  phone: [
    {
      validator: (_rule: FormItemRule, value: string) => {
        if (!value)
          return new Error('请输入手机号')
        if (!checkPhone(value) || !value)
          return new Error('请输入正确的手机号')
        return true
      },
      trigger: 'blur',
    },
  ],
  email: [
    {
      validator: (_rule: FormItemRule, value: string) => {
        if (!value || (isString(value) && checkEmail(value)))
          return true
        else
          return new Error('请输入正确邮箱')
      },
      trigger: 'blur',
    },
  ],
}

async function validator() {
  const { isOk } = await validateHandle(formRef)
  if (!isOk)
    return false

  emits('changeCurrentStep', 1)
}

defineExpose({
  formRef,
})
</script>

<template>
  <div>
    <div class="bg-white rounded-md p-4xl mt-4xl">
      <div v-if="$route.query.isSite" class="text-3 text-slate-4 mb-sm">
        <span class="text-blue-5 font-bold">中国质量监管网协作单位汽车投诉网</span>
      </div>
      <div class="text-3 text-slate-4 mb-sm">
        （<span class="text-red-5">*</span>号为必填选项，以方便我们能准确及时的与您取得联系，请您认真填写表格内容。）
      </div>
      <NForm
        ref="formRef"
        :model="formData"
        :rules="rules"
        :label-width="150"
        label-placement="left"
        class="px-40"
        size="medium"
      >
        <NGrid :cols="24" :x-gap="24">
          <NFormItemGi first :span="12" path="userName" required label="车主姓名">
            <NInput v-model:value="formData.userName" placeholder="请输入车主姓名" />
          </NFormItemGi>
          <NFormItemGi first :span="12" path="sex" required label="车主性别">
            <NRadioGroup v-model:value="formData.sex">
              <NRadio v-for="v in SEX" :key="v.value" :value="v.value" :label="v.label" />
            </NRadioGroup>
          </NFormItemGi>
          <NFormItemGi first :span="12" path="phone" required label="手机号">
            <NInput v-model:value="formData.phone" placeholder="请输入手机号" />
          </NFormItemGi>
          <NFormItemGi first :span="12" path="email" label="邮箱地址">
            <NInput v-model:value="formData.email" placeholder="请输入邮箱地址" />
          </NFormItemGi>
        </NGrid>
      </NForm>
    </div>
    <div class="flex items-center justify-center mt-xl">
      <button class="btn-primary px-4xl" @click="validator()">
        下一步
      </button>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
